import React from 'react'
import { useHistory } from 'react-router'

import { User } from 'types/api/user.model'
import {
	ImpersonatingStatusContainer,
	ImpersonatingStatusContent,
	ImpersonatingStatusText,
	ImpersonatingStatusButton,
} from './ImpersonatingStatus.styled'
import { scenes } from 'scenes/scenes'

interface ImpersonatingStatusProps {
	user: User | null
}

const ImpersonatingStatus = ({ user }: ImpersonatingStatusProps) => {
	const history = useHistory()
	const userObject = {
		email: user?.email,
		name: user?.firstName
			? `${user.firstName} ${user?.lastName || ''}`
			: user?.lastName || '',
	}

	const handleExitImpersonation = async () => {
		history.replace(scenes.logout.url)
	}

	return (
		<ImpersonatingStatusContainer>
			<ImpersonatingStatusContent>
				<ImpersonatingStatusText>
					{`You are currently impersonating`}&nbsp;
					<strong style={{ fontWeight: '600' }}>
						{userObject?.email} ({userObject?.name})
					</strong>
					&nbsp;
					{user?.impersonatorEmail && 'as'}
					&nbsp;
					<strong style={{ fontWeight: '600' }}>
						{user?.impersonatorEmail}
					</strong>
				</ImpersonatingStatusText>

				<ImpersonatingStatusButton
					text={'Exit impersonation mode'}
					onClick={handleExitImpersonation}
				/>
			</ImpersonatingStatusContent>
		</ImpersonatingStatusContainer>
	)
}

export default ImpersonatingStatus
